import { Component, OnInit } from '@angular/core';
import { InitialInterviewApiService } from "../initial-interview-api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { MatButton } from "@angular/material/button";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgIf, NgOptimizedImage } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { PageService } from "../service/page-service";
import { ActivityType, InitialInterviewPage, PayTransparencyCategory } from "../../../enums";
import { initialInterviewClickIllDoThisLater, isNumbersEqual, routeGatherToProfileOrThankYou } from '../util';
import { Gather } from "../../../gather/gather-typings";
import { TalentProfileApiService } from '../../talent-profile/talent-profile-api.service';
import { FeatureService, TalentAppFeatures } from '../../../service/feature.service';
import { PayTransparencyService } from "../service/payTransparency-service";
import { OrderPayTransparencyData } from "../../../../typings";
import { Country } from '../../../gather/enums';
import { VideoInterviewFlowService } from "../video-interview/service/video-interview-flow.service";

@Component({
    imports: [
        MatButton,
        TranslateModule,
        NgIf,
        MatProgressSpinnerModule
    ],
    selector: 'app-initial-interview-application-submit-page',
    templateUrl: './initial-interview-application-submit-page.component.html',
    styleUrl: './initial-interview-application-submit-page.component.scss'
})
export class InitialInterviewApplicationSubmitPageComponent implements OnInit {
  jobPostingId: number;
  jobTitle: string;
  orderId: number;
  talent: Talent;
  showLaterButton: boolean = true;
  contextText: string = String(this.translateService.instant('talent-happy-path.initial-interview-questions.application-submit-page.header'));
  gatherUUID: string = this.route.snapshot.queryParams['gatheruuid'];
  gather: Gather;
  isGather: boolean = this.gatherUUID != undefined;
  talentProfilePath: string = '/talent-profile';
  thankYouPath: string = '/thank-you';

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService,
    private initialInterviewApi: InitialInterviewApiService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PageService,
    private talentProfileApiService: TalentProfileApiService,
    private featureService: FeatureService,
    private initialInterviewApiService: InitialInterviewApiService,
    private payTransparencyService: PayTransparencyService,
    private videoInterviewFlowService: VideoInterviewFlowService
  ) {}

  ngOnInit() {
    this.talent = this.talentHappyPathDataService.talent;
    this.jobPostingId = this.talentHappyPathDataService.postingId;
    this.jobTitle = this.talentHappyPathDataService.postingInfo.jobTitle;
    this.orderId = this.talentHappyPathDataService.postingInfo.orderId;

    if (this.isGather) {
      this.contextText = String(this.translateService.instant('talent-happy-path.initial-interview-questions.application-submit-page.header-interest'));
      this.gather = this.talentHappyPathDataService.gather;
    }
  }

  clickIllDoThisLater() {
    if (this.isGather) {
      initialInterviewClickIllDoThisLater('', this.talent, this.jobPostingId, this.orderId, this.jobTitle, this.initialInterviewApi, this.talentHappyPathDataService, this.router, this.gatherUUID);
      routeGatherToProfileOrThankYou(this.talentHappyPathDataService.gather.talentPersonId, this.talentProfileApiService, this.router)
    } else {
      initialInterviewClickIllDoThisLater(this.talentProfilePath, this.talent, this.jobPostingId, this.orderId, this.jobTitle, this.initialInterviewApi, this.talentHappyPathDataService, this.router);
    }
  }

  clickLetsDoThis() {
    if (this.payTransparencyService.getPayTransparencyData() != null) {
      this.handleNavigation(this.payTransparencyService.getPayTransparencyData());
    }  else {
      this.initialInterviewApiService.readTalentPayTransparencyData(
        this.talentHappyPathDataService.talent.personId,
        this.talentHappyPathDataService.postingInfo.orderId
      ).subscribe(data => {
        this.payTransparencyService.setPayTransparencyData(data);
        this.handleNavigation(data);
      });
    }
  }

  handleNavigation(data: OrderPayTransparencyData) {
    let minPayRate: number;
    let maxPayRate: number;
    if (data.payTransparencyCategoryId === PayTransparencyCategory.SALARY) {
      minPayRate = data.minSalary;
      maxPayRate = data.maxSalary;
    } else {
      minPayRate = data.minRate;
      maxPayRate = data.maxRate;
    }
    this.initialInterviewApi.createTalentProfileActivity(
      ActivityType.INITIAL_INTERVIEW_QUESTIONS_STARTED, this.talent.personId, this.orderId, this.jobPostingId
    );
    if (this.featureService.getFeature(TalentAppFeatures.APPLICANT_PAY_TRANSPARENCY_FEATURE) && !isNumbersEqual(minPayRate, maxPayRate) && this.talentHappyPathDataService.postingInfo?.countryId != Country.Germany) {
      this.pageService.setActivePage(InitialInterviewPage.PAY_TRANSPARENCY);
    } else if (this.videoInterviewFlowService.shouldShowForWorkflowB()) {
      // Workflow B: video interview before the IIQ questions (no pay transparency for this posting).
      this.videoInterviewFlowService.enterVideoInterview(InitialInterviewPage.QUESTIONS_PAGE);
    } else {
      this.pageService.setActivePage(InitialInterviewPage.QUESTIONS_PAGE);
    }
  }
}
